const fragment = `
  id
  hookUrl
  events
  enabled
  createdAt
`;

export const getZapierWebhookQuery = `
  query GetZapierWebhook($companyId: Int!) {
    item: getZapierWebhook(companyId: $companyId) {
      ${fragment}
    }
  }
`;

export const listWebhooksQuery = `
  query ListWebhooks(
    $filter: WebhookFilterInput
  ) {
    items: listWebhooks(filter: $filter) {
      ${fragment}
    }
  }
`;

export const getWebhookQuery = `
  query GetWebhook($id: Int!) {
    item: getWebhook(id: $id) {
      ${fragment}
    }
  }
`;

export const createWebhookQuery = `
  mutation CreateWebhook(
    $input: CreateWebhookInput!
  ) {
    item: createWebhook(input: $input) {
      ${fragment}
    }
  }
`;

export const updateWebhookQuery = `
  mutation UpdateWebhook(
    $input: UpdateWebhookInput!
  ) {
    item: updateWebhook(input: $input) {
      ${fragment}
    }
  }
`;

export const deleteWebhookQuery = `
  mutation DeleteWebhook(
    $id: Int!
  ) {
    item: deleteWebhook(id: $id) {
      ${fragment}
    }
  }
`;

export const deleteZapierWebhooksQuery = `
  mutation DeleteZapierWebhooks(
    $companyId: Int!
  ) {
    deletedWebhooksCount: deleteZapierWebhooks(companyId: $companyId)
  }
`;
